import React, { Fragment, useEffect, useState } from 'react';

import { Control } from '@vlabs/uikit';

import { useEventListFiltersTranslation } from '../../../i18n';
import { useEventListFilters } from '../../../useEventListFilters';
import st from '../../popovers.module.sass';

type AddressField = 'cities' | 'areas' | 'districts' | 'streets' | 'house_numbers';

const parseValues = (value: string): string[] | undefined => {
  const items = value.split(',').map((item) => item.trim()).filter(Boolean);
  return items.length > 0 ? items : undefined;
};

export function AddressTab(): React.JSX.Element {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFiltersDebounced, updateFilters } = useEventListFilters();

  const [local, setLocal] = useState<Record<AddressField, string>>({
    cities: '',
    areas: '',
    districts: '',
    streets: '',
    house_numbers: '',
  });

  useEffect(() => {
    setLocal({
      cities: filters.cities?.join(',') ?? '',
      areas: filters.areas?.join(',') ?? '',
      districts: filters.districts?.join(',') ?? '',
      streets: filters.streets?.join(',') ?? '',
      house_numbers: filters.house_numbers?.join(',') ?? '',
    });
  }, [filters]);

  const handleChange = (field: AddressField) => (value: string) => {
    setLocal((prev) => ({ ...prev, [field]: value }));
    updateFiltersDebounced({ [field]: parseValues(value) });
  };

  const handleClear = (field: AddressField) => () => {
    setLocal((prev) => ({ ...prev, [field]: '' }));
    updateFilters({ [field]: undefined });
  };

  return (
    <Fragment>
      <div>
        <Control.Input
          id="cities"
          isClearable
          label={t('cities')}
          name="cities"
          onChangeValue={handleChange('cities')}
          onClear={handleClear('cities')}
          value={local.cities}
        />
      </div>
      <div>
        <Control.Input
          id="areas"
          isClearable
          label={t('areas')}
          name="areas"
          onChangeValue={handleChange('areas')}
          onClear={handleClear('areas')}
          value={local.areas}
        />
      </div>
      <div>
        <Control.Input
          id="districts"
          isClearable
          label={t('districts')}
          name="districts"
          onChangeValue={handleChange('districts')}
          onClear={handleClear('districts')}
          value={local.districts}
        />
      </div>
      <div className={st.RowInputsWrapper}>
        <div>
          <Control.Input
            id="streets"
            isClearable
            label={t('streets')}
            name="streets"
            onChangeValue={handleChange('streets')}
            onClear={handleClear('streets')}
            value={local.streets}
          />
        </div>
        <div>
          <Control.Input
            id="house_numbers"
            isClearable
            label={t('house_numbers')}
            name="house_numbers"
            onChangeValue={handleChange('house_numbers')}
            onClear={handleClear('house_numbers')}
            value={local.house_numbers}
          />
        </div>
      </div>
    </Fragment>
  );
}
